import { FC } from "react"
import s from "@pages/fid_view/styles.module.css"
import { Box, Typography } from "@mui/material"
import {
  cardInfo,
  cardInfoIcon,
  cardTitle,
} from "@components/CardEvent/CardEvent/CardEventStyles"

import { selectUserId } from "@app/data/appTokensStore"
import {useGetUserOrganizationEventsQuery, useGetUserProfileQuery} from "@app/data/userDataSlice/userApi.ts";

import CalendarIconCard from "/src/assets/svg/card-icons-pack/calendar-icon.svg?react"
import ClockIconCard from "/src/assets/svg/card-icons-pack/clock-icon.svg?react"
import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi"
import {useAppSelector} from "@app/hooks.ts";
export interface TimeInfoContentProps {
  eventInfo?: DetailedEventInSearchDto
}
const formatTime = (startTime?: string): string | null => {
  if (!startTime) return null
  const eventDatetime = Date.parse(startTime || "")
  const timeFormatter = new Intl.DateTimeFormat("ru", {
    hour: "numeric",
    minute: "numeric",
  })
  return timeFormatter.format(eventDatetime)
}
const formatDate = (startTime?: string): string | null => {
  if (!startTime) return null
  const eventDatetime = Date.parse(startTime || "")
  const dateFormatter = new Intl.DateTimeFormat("ru", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })

  return dateFormatter.format(eventDatetime)
}
const TimeInfoContent: FC<TimeInfoContentProps> = ({ eventInfo }) => {
  const id = useAppSelector(selectUserId)
  if (!eventInfo) return null
  if (eventInfo?.is_private && !eventInfo?.start_time && (eventInfo.organizer_id !== id || id === undefined)) {
    return (
      <Typography gutterBottom variant="h6" component="div" sx={cardTitle}>
        Это приватное событие. Дата и время проведения скрыты настройками
        приватности
      </Typography>
    )
  }

  return (
    <div className={s.description_box}>
      <Typography gutterBottom variant="h6" component="div" sx={cardTitle}>
        Дата и время проведения:
      </Typography>
      <Box sx={cardInfo}>
        <div style={cardInfoIcon}>
          <CalendarIconCard stroke={"var(--secondary-text)"} />
          <Typography variant="body2" color={`var(--secondary-text)`}>
            {formatDate(eventInfo?.start_time)}
          </Typography>
        </div>
      </Box>
      <Box sx={cardInfo}>
        <div style={cardInfoIcon}>
          <ClockIconCard stroke={"var(--secondary-text)"} />
          <Typography variant="body2" color={`var(--secondary-text)`}>
            {formatTime(eventInfo?.start_time)}
          </Typography>
        </div>
      </Box>
    </div>
  )
}

export default TimeInfoContent
